import axios from "axios";
import { base } from "../base";

// Same public form as the partnerships enquiry and the brochure download.
// Tagged so the API can email this exact breakdown back to the address.
export const submitRoiResult = async ({
  email,
  applicants,
  minutes,
  roles,
  marketingConsent,
  landingPage,
  utm,
}) => {
  const domain = String(email).split("@")[1] || "";
  const companyName = domain.split(".")[0] || "company";
  const response = await axios.post(`${base}/api/public/form`, {
    source: "roi_calculator",
    email,
    fullName: "there",
    companyName,
    assesmentPerMonth: applicants * roles,
    additionalComments: `${applicants} applicants x ${minutes} min screening`,
    marketingConsent: marketingConsent === true,
    landingPage,
    utm,
    roiApplicants: applicants,
    roiMinutes: minutes,
    roiRolesPerMonth: roles,
  });
  return response.data;
};

// Older APIs reject `source: roi_calculator`. Keep the lead anyway, with the
// breakdown in the comment the partnerships inbox already shows.
export const submitRoiResultFallback = async ({
  email,
  applicants,
  minutes,
  roles,
  marketingConsent,
  landingPage,
  utm,
}) => {
  const domain = String(email).split("@")[1] || "";
  const companyName = domain.split(".")[0] || "company";
  const response = await axios.post(`${base}/api/public/form`, {
    email,
    fullName: "there",
    companyName,
    assesmentPerMonth: applicants * roles,
    additionalComments: `${applicants} applicants x ${minutes} min screening`,
    marketingConsent: marketingConsent === true,
    landingPage,
    utm,
  });
  return response.data;
};
